import React from 'react';
import { Grid, Ruler, Package, DollarSign } from 'lucide-react';

/**
 * Компонент секции параметров плитки
 */
const TileParametersSection = ({ formData, handleInputChange, errors, tileTypes }) => {
  return (
    <div className="mb-6 bg-fuchsia-50 dark:bg-fuchsia-900/20 p-4 rounded-lg border border-fuchsia-100 dark:border-fuchsia-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Grid className="w-5 h-5 mr-2 text-fuchsia-500" />
        Параметры плитки
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        {/* Тип плитки */}
        <div>
          <label htmlFor="tileType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип плитки
          </label>
          <select
            id="tileType"
            name="tileType"
            value={formData.tileType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {tileTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        {/* Форма плитки */}
        <div>
          <label htmlFor="tileShape" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Форма плитки
          </label>
          <select
            id="tileShape"
            name="tileShape"
            value={formData.tileShape}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="square">Квадратная</option>
            <option value="rectangle">Прямоугольная</option>
            <option value="hexagon">Шестиугольная</option>
            <option value="custom">Другая</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        {/* Ширина плитки */}
        <div>
          <label htmlFor="tileWidth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Ruler className="w-4 h-4 mr-2 text-fuchsia-500" />
            Ширина (см)
          </label>
          <input
            type="text"
            id="tileWidth"
            name="tileWidth"
            value={formData.tileWidth}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.tileWidth ? 'input-error' : ''}`}
            placeholder="Ширина плитки"
          />
          {errors.tileWidth && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.tileWidth}
            </p>
          )}
        </div>

        {/* Длина плитки */}
        <div>
          <label htmlFor="tileLength" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Ruler className="w-4 h-4 mr-2 text-fuchsia-500" />
            Длина (см)
          </label>
          <input
            type="text"
            id="tileLength"
            name="tileLength"
            value={formData.tileLength}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.tileLength ? 'input-error' : ''}`}
            placeholder="Длина плитки"
          />
          {errors.tileLength && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.tileLength}
            </p>
          )}
        </div>

        {/* Толщина плитки */}
        <div>
          <label htmlFor="tileThickness" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Ruler className="w-4 h-4 mr-2 text-fuchsia-500" />
            Толщина (см)
          </label>
          <input
            type="text"
            id="tileThickness"
            name="tileThickness"
            value={formData.tileThickness}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.tileThickness ? 'input-error' : ''}`}
            placeholder="Толщина плитки"
          />
          {errors.tileThickness && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.tileThickness}
            </p>
          )}
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Количество плиток в упаковке */}
        <div>
          <label htmlFor="tilesInPackage" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Package className="w-4 h-4 mr-2 text-fuchsia-500" />
            Штук в упаковке
          </label>
          <input
            type="text"
            id="tilesInPackage"
            name="tilesInPackage"
            value={formData.tilesInPackage}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.tilesInPackage ? 'input-error' : ''}`}
            placeholder="Плиток в упаковке"
          />
          {errors.tilesInPackage && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.tilesInPackage}
            </p>
          )}
        </div>

        {/* Площадь в упаковке */}
        <div>
          <label htmlFor="packageArea" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Package className="w-4 h-4 mr-2 text-fuchsia-500" />
            Площадь упаковки (м²)
          </label>
          <input
            type="text"
            id="packageArea"
            name="packageArea"
            value={formData.packageArea}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.packageArea ? 'input-error' : ''}`}
            placeholder="Площадь в упаковке"
          />
          {errors.packageArea && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.packageArea}
            </p>
          )}
        </div>

        {/* Цена упаковки */}
        <div>
          <label htmlFor="packagePrice" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <DollarSign className="w-4 h-4 mr-2 text-fuchsia-500" />
            Цена упаковки (₽)
          </label>
          <input
            type="text"
            id="packagePrice"
            name="packagePrice"
            value={formData.packagePrice}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.packagePrice ? 'input-error' : ''}`}
            placeholder="Цена упаковки"
          />
          {errors.packagePrice && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.packagePrice}
            </p>
          )}
        </div>
      </div>

      <div className="mt-3 p-3 bg-white dark:bg-gray-800/50 rounded-lg border border-gray-200 dark:border-gray-700 text-xs text-gray-700 dark:text-gray-300">
        <div className="flex items-start">
          <Package className="w-4 h-4 text-fuchsia-500 mt-0.5 mr-2 flex-shrink-0" />
          <div>
            {formData.tileType === 'mosaic' 
              ? 'Для мозаики укажите размер одного элемента мозаики. Площадь упаковки обычно указана на упаковке.' 
              : 'Информацию о размерах, количестве в упаковке и площади можно найти на упаковке или в техническом паспорте плитки. Например, если ширина плитки 30 см, длина 30 см и в упаковке 10 штук, площадь упаковки составит 0.9 м².'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TileParametersSection;